var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQueensland(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "47px",
    height: "52px",
    viewBox: "0 0 47 52",
    enableBackground: "new 0 0 47 52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.38,
    y: 29.237,
    transform: "matrix(0.3535 0.9354 -0.9354 0.3535 32.0555 18.0228)",
    fill: "#FFFFFF",
    width: 1.218,
    height: 5.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.38,
    y: 32.068,
    transform: "matrix(0.1709 0.9853 -0.9853 0.1709 36.6754 25.8316)",
    fill: "#FFFFFF",
    width: 1.217,
    height: 5.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.38,
    y: 34.282,
    transform: "matrix(0.1531 0.9882 -0.9882 0.1531 39.0107 28.3101)",
    fill: "#FFFFFF",
    width: 1.218,
    height: 5.265
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.517,
    y: 36.462,
    transform: "matrix(0.0833 0.9965 -0.9965 0.0833 41.9416 32.8286)",
    fill: "#FFFFFF",
    width: 1.219,
    height: 5.498
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.387,
    y: 41.227,
    fill: "#FFFFFF",
    width: 5.142,
    height: 1.218
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.387,
    y: 43.459,
    fill: "#FFFFFF",
    width: 5.142,
    height: 1.218
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.387,
    y: 45.624,
    fill: "#FFFFFF",
    width: 5.142,
    height: 1.218
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.387,
    y: 48.127,
    fill: "#FFFFFF",
    width: 5.142,
    height: 1.218
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M8.19,51.438l-2.729-1.068V30.584l5.615,1.295v11.584l-2.524,1.023L8.19,51.438z M6.679,49.538 l0.383,0.149l0.314-6.038l2.482-1.007v-9.795l-3.18-0.732V49.538z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M8.911,52v-8.707l1.278-0.845l3.496,1.698l0.321,3.98l1.535,0.004l1.759,0.195V38.143l1.015-1.068v-4.173 l0.827-1.722l0.269-2.483l2.012-4.992h3.586l0.167,24.009l1.154-0.63l2.466,0.436l5.342,0.147l2.318,0.498l1.907,0.706 l3.047,2.252L8.911,52z M10.129,43.947v6.802l27.713-0.747l-0.064-0.049l-1.704-0.631l-2.135-0.452l-5.311-0.144l-2.091-0.369 l-2.566,1.4l-0.172-24.835h-1.555l-1.642,4.074l-0.272,2.522l-0.797,1.661v4.381l-1.015,1.067v11.06l-3.078-0.343h-2.558 l-0.355-4.407l-2.246-1.091L10.129,43.947z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.49,48.465H47c0,0-1.184,2.098-3.247,2.098C43.753,50.563,39.49,51.035,39.49,48.465z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M43.448,43.188c0,0-4.499,2.301-3.822,5.142h2.841L43.448,43.188z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "43.448,45.758 43.448,48.329 47,48.329 43.448,43.594  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M29.275,47.518v-2.773c0,0-1.895,1.286-2.029,1.488c-0.136,0.203,0-1.218,0-1.218L26.23,45.15l1.15-1.082 c0,0-0.271-0.611-0.744-0.475c0,0,1.218-0.948,2.639,0h0.474c0,0,0.067-1.42,1.218-2.164c0,0-1.218-0.137-1.895,0.405 c0,0-0.405-1.488,1.895-1.556c0,0,0.88-0.783-1.218-1.068c0,0,1.962-2.111,4.059,0.662c0,0,1.827-2.39,4.669-0.891 c0,0-0.475-0.26-0.948,1.025c0,0,0.475-0.404,0.948,0.948c0,0-0.474-0.136-0.813,0.474c0,0,0.745,0.203,0.813,0.947 c0,0-0.474-0.475-1.624-0.068c0,0,0.812,0.473,0.812,1.285c0,0-1.556-1.566-2.841-0.614l-0.745,0.208l-0.338,4.33l0.135,0.339 l-1.521-0.271v-3.248c0,0-0.44-0.338-0.508,0.475c0,0-0.541,0.541-0.744-0.406l0.203,0.947c0,0,0.001-0.271-0.744-0.609 l-0.136,3.112L29.275,47.518z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M37.102,35.114h-2.146v-2.755c-0.733-0.391-1.193-1.146-1.193-1.991c0-1.249,1.017-2.267,2.267-2.267 c1.249,0,2.267,1.018,2.267,2.267c0,0.846-0.461,1.601-1.193,1.991V35.114z M35.767,34.303h0.523v-2.48l0.26-0.101 c0.566-0.219,0.933-0.75,0.933-1.354c0-0.802-0.652-1.454-1.454-1.454c-0.803,0-1.455,0.652-1.455,1.454 c0,0.604,0.366,1.135,0.934,1.354l0.26,0.101V34.303z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueensland);
export default __webpack_public_path__ + "static/media/queensland.2cc7bddfe8be285e5543e150fb97422f.svg";
export { ForwardRef as ReactComponent };